module.exports = __webpack_public_path__ + "img/Z71_05.38de4658.jpg";